import { render, staticRenderFns } from "./ClickToBuy.vue?vue&type=template&id=f5bd4562&scoped=true"
import script from "./ClickToBuy.vue?vue&type=script&lang=js"
export * from "./ClickToBuy.vue?vue&type=script&lang=js"
import style0 from "./ClickToBuy.vue?vue&type=style&index=0&id=f5bd4562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bd4562",
  null
  
)

export default component.exports